/**
 * Ist ein HTML-Textkasten WIRKLICH leer?
 *
 * Bisher zaehlten nur Buchstaben: Markup rausstreichen, was uebrig bleibt,
 * entscheidet. Fuer die urspruengliche Aufgabe stimmte das — Lexical erzeugt
 * aus einem geleerten Kasten `<p><br></p>`, und dafuer wollte niemand eine
 * weisse Box sehen.
 *
 * Jans Fund 23.09.2026 (Heatscore-Passwortpruefer): Ein Kasten, in dem NUR
 * eine eingebettete Seite steht (`<iframe>`), hat keinen einzigen Buchstaben —
 * er galt damit als leer. Folge: Der Viewer baute die Box gar nicht erst
 * (VisualStoryPlayer), und der Pro-Editor LOESCHTE den Text beim Laden
 * (sanitizeEmptySlideTexts). Im Editor war die Einbettung da, nach dem
 * Speichern war sie weg.
 *
 * Deshalb zaehlt jetzt auch eingebetteter Inhalt: iframe, video, img, svg,
 * canvas, object, embed, audio, picture. Ein Kasten mit Bild oder Einbettung
 * ist nicht leer, auch ohne ein einziges Wort.
 */

/** Elemente, die den Kasten auch ohne Text fuellen. */
const INHALT_TAGS = /<\s*(iframe|video|img|svg|canvas|object|embed|audio|picture)\b/i;

export function textboxLeer(html: string | null | undefined): boolean {
    if (!html) return true;
    if (INHALT_TAGS.test(html)) return false;
    const text = html
        .replace(/<br\s*\/?>/gi, "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/[\s ]/g, "")
        .trim();
    return text === "";
}
